import React from 'react';

const SeoCitiesContext = React.createContext();

export const SeoCitiesProvider = SeoCitiesContext.Provider;
export const SeoCitiesConsumer = SeoCitiesContext.Consumer;

export default SeoCitiesContext;
